import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";

export function ExclusiveSetter({ p, onDone, compact }) {
  const m = p.mediation || {};
  const [excl, setExcl] = useState(m.exclusive ?? null);
  const [months, setMonths] = useState(m.duration_months || 6);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/processes/${p.id}`, { mediation: { exclusive: excl, duration_months: Number(months) || null } });
      toast.success("Exclusividade indicada"); onDone?.();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const pill = (v, l) => (
    <button type="button" onClick={() => setExcl(v)} data-testid={`exclusive-${v ? "sim" : "nao"}`}
      className={`px-3 py-1.5 rounded-lg text-sm font-semibold border transition-colors ${excl === v ? "navy-bg text-white border-transparent" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`}>{l}</button>
  );
  return (
    <div className={`${compact ? "" : "rounded-xl border border-slate-200 bg-slate-50/60 p-3"} space-y-2`} data-testid="exclusive-setter">
      {!compact && <div className="text-sm font-semibold text-slate-800">Indicar se é exclusivo</div>}
      <div className="flex flex-wrap items-center gap-2">
        {pill(true, "Sim")}{pill(false, "Não")}
        <span className="inline-flex items-center gap-1.5 text-sm text-slate-500 ml-1">Prazo
          <Input type="number" min={1} max={36} value={months} onChange={(e) => setMonths(e.target.value)} className="h-8 w-16" data-testid="exclusive-months" />meses</span>
        <button onClick={save} disabled={busy || excl === null} className="ml-auto px-3 py-1.5 rounded-lg text-sm font-semibold navy-bg text-white disabled:opacity-40" data-testid="exclusive-save">Guardar</button>
      </div>
    </div>
  );
}
